// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__Z7oHW","colMaxWidth":"Table_colMaxWidth__1CebN"};